export var VisitedScreenEnum;
(function (VisitedScreenEnum) {
    VisitedScreenEnum["HOME"] = "home";
    VisitedScreenEnum["ACTIVITIES"] = "activities";
    VisitedScreenEnum["BLOCKS"] = "blocks";
    VisitedScreenEnum["BLOCKSJR"] = "blocksjr";
    VisitedScreenEnum["CONFIG"] = "config";
    VisitedScreenEnum["SENSORS_DASHBOARD"] = "sens-dash";
    VisitedScreenEnum["CODEWHEEL"] = "codewheel";
    VisitedScreenEnum["MAZE"] = "maze";
    VisitedScreenEnum["JUMPING_GAME"] = "jumping-game";
    VisitedScreenEnum["ROBOFLY_GAME"] = "robofly-game";
    VisitedScreenEnum["CONTROLLER"] = "controller";
    VisitedScreenEnum["CALIBRATION"] = "calibration";
    VisitedScreenEnum["HELP"] = "help";
    VisitedScreenEnum["GAMES"] = "games";
    VisitedScreenEnum["SKIING_GAME"] = "skiing-game";
})(VisitedScreenEnum || (VisitedScreenEnum = {}));
export var HeartbeatTypeEnum;
(function (HeartbeatTypeEnum) {
    HeartbeatTypeEnum["SESSION"] = "session";
    HeartbeatTypeEnum["SCREEN"] = "screen";
    HeartbeatTypeEnum["ACTIVITY"] = "activity";
})(HeartbeatTypeEnum || (HeartbeatTypeEnum = {}));
export var ServerEndpoints;
(function (ServerEndpoints) {
    ServerEndpoints["TRACK_CONSENT"] = "track-consent";
    ServerEndpoints["START_SESSION"] = "start-session";
    ServerEndpoints["HEARTBEAT"] = "heartbeat";
    ServerEndpoints["SCREEN_VISIT"] = "screen-visit";
    ServerEndpoints["ACTIVITY_VISIT"] = "activity-visit";
    ServerEndpoints["GET_CONSENT_RAW_DATA"] = "get-consent-raw-data";
    ServerEndpoints["GET_SESSIONS_RAW_DATA"] = "get-sessions-raw-data";
    ServerEndpoints["GET_SESSION_HEARTBEATS_RAW_DATA"] = "get-session-heartbeats-raw-data";
    ServerEndpoints["GET_SCREEN_HEARTBEATS_RAW_DATA"] = "get-screen-heartbeats-raw-data";
    ServerEndpoints["GET_SCREEN_VISITS_RAW_DATA"] = "get-screen-visits-raw-data";
    ServerEndpoints["GET_ACTIVITY_VISITS_RAW_DATA"] = "get-activity-visits-raw-data";
    ServerEndpoints["GET_ACTIVITY_HEARTBEATS_RAW_DATA"] = "get-activity-heartbeats-raw-data";
    ServerEndpoints["GET_SESSIONS_N_PER_WEEK_PROCESSED_DATA"] = "get-sessions-n-per-week-processed-data";
    ServerEndpoints["GET_UNIQUE_DEVICES_N_PER_WEEK_PROCESSED_DATA"] = "get-unique-devices-n-per-week-processed-data";
    ServerEndpoints["GET_UNIQUE_COGS_N_PER_WEEK_PROCESSED_DATA"] = "get-unique-cogs-n-per-week-processed-data";
    ServerEndpoints["GET_UNIQUE_MARTYS_N_PER_WEEK_PROCESSED_DATA"] = "get-unique-martys-n-per-week-processed-data";
    ServerEndpoints["GET_VISITED_SCREENS_FREQUENCY_PER_WEEK_PROCESSED_DATA"] = "get-visited-screens-frequency-per-week-processed-data";
    ServerEndpoints["GET_VISITED_ACTIVITIES_FREQUENCY_PER_WEEK_PROCESSED_DATA"] = "get-visited-activities-frequency-per-week-processed-data";
    ServerEndpoints["GET_SESSIONS_TIME_SPENT_PER_WEEK_PROCESSED_DATA"] = "get-sessions-time-spent-per-week-processed-data";
    ServerEndpoints["GET_SCREENS_TIME_SPENT_PER_WEEK_PROCESSED_DATA"] = "get-screens-time-spent-per-week-processed-data";
    ServerEndpoints["GET_ACTIVITIES_TIME_SPENT_PER_WEEK_PROCESSED_DATA"] = "get-activities-time-spent-per-week-processed-data";
})(ServerEndpoints || (ServerEndpoints = {}));
export var FirestoreCollectionsRawEnum;
(function (FirestoreCollectionsRawEnum) {
    FirestoreCollectionsRawEnum["CONSENTS"] = "consents";
    FirestoreCollectionsRawEnum["SESSIONS"] = "sessions";
    FirestoreCollectionsRawEnum["SESSION_HEARTBEATS"] = "sessionHeartbeats";
    FirestoreCollectionsRawEnum["SCREEN_HEARTBEATS"] = "screenHeartbeats";
    FirestoreCollectionsRawEnum["SCREEN_VISITS"] = "screenVisits";
    FirestoreCollectionsRawEnum["ACTIVITY_VISITS"] = "activityVisits";
    FirestoreCollectionsRawEnum["ACTIVITY_HEARTBEATS"] = "activityHeartbeats";
})(FirestoreCollectionsRawEnum || (FirestoreCollectionsRawEnum = {}));
export var FirestoreCollectionsProcessedEnumLevel1;
(function (FirestoreCollectionsProcessedEnumLevel1) {
    FirestoreCollectionsProcessedEnumLevel1["SESSIONS"] = "sessions";
    FirestoreCollectionsProcessedEnumLevel1["DEVICES"] = "devices";
    FirestoreCollectionsProcessedEnumLevel1["ROBOTS"] = "robots";
    FirestoreCollectionsProcessedEnumLevel1["SCREENS"] = "screens";
    FirestoreCollectionsProcessedEnumLevel1["ACTIVITIES"] = "activities";
    FirestoreCollectionsProcessedEnumLevel1["HEARTBEATS"] = "heartbeats";
    FirestoreCollectionsProcessedEnumLevel1["METADATA"] = "metadata";
})(FirestoreCollectionsProcessedEnumLevel1 || (FirestoreCollectionsProcessedEnumLevel1 = {}));
export var FirestoreCollectionsProcessedEnumLevel2;
(function (FirestoreCollectionsProcessedEnumLevel2) {
    FirestoreCollectionsProcessedEnumLevel2["SESSIONS_N_PER_WEEK"] = "sessionsNPerWeek";
    FirestoreCollectionsProcessedEnumLevel2["SESSIONS_N_PER_WEEK_METADATA"] = "sessionsNPerWeekMetadata";
    FirestoreCollectionsProcessedEnumLevel2["UNIQUE_DEVICES_N_PER_WEEK"] = "uniqueDevicesNPerWeek";
    FirestoreCollectionsProcessedEnumLevel2["UNIQUE_DEVICES_N_PER_WEEK_METADATA"] = "uniqueDevicesNPerWeekMetadata";
    FirestoreCollectionsProcessedEnumLevel2["VISITED_SCREENS_FREQUENCY_PER_WEEK"] = "visitedScreensFrequencyPerWeek";
    FirestoreCollectionsProcessedEnumLevel2["VISITED_SCREENS_FREQUENCY_PER_WEEK_METADATA"] = "visitedScreensFrequencyPerWeekMetadata";
    FirestoreCollectionsProcessedEnumLevel2["VISITED_ACTIVITIES_FREQUENCY_PER_WEEK"] = "visitedActivitiesFrequencyPerWeek";
    FirestoreCollectionsProcessedEnumLevel2["VISITED_ACTIVITIES_FREQUENCY_PER_WEEK_METADATA"] = "visitedActivitiesFrequencyPerWeekMetadata";
    FirestoreCollectionsProcessedEnumLevel2["UNIQUE_COGS_PER_WEEK"] = "uniqueCogsPerWeek";
    FirestoreCollectionsProcessedEnumLevel2["UNIQUE_COGS_PER_WEEK_METADATA"] = "uniqueCogsPerWeekMetadata";
    FirestoreCollectionsProcessedEnumLevel2["UNIQUE_MARTYS_PER_WEEK"] = "uniqueMartysPerWeek";
    FirestoreCollectionsProcessedEnumLevel2["UNIQUE_MARTYS_PER_WEEK_METADATA"] = "uniqueMartysPerWeekMetadata";
    FirestoreCollectionsProcessedEnumLevel2["SESSIONS_TIME_SPENT_PER_WEEK"] = "sessionsTimeSpentPerWeek";
    FirestoreCollectionsProcessedEnumLevel2["SESSIONS_TIME_SPENT_PER_WEEK_METADATA"] = "sessionsTimeSpentPerWeekMetadata";
    FirestoreCollectionsProcessedEnumLevel2["SCREENS_TIME_SPENT_PER_WEEK"] = "screensTimeSpentPerWeek";
    FirestoreCollectionsProcessedEnumLevel2["SCREENS_TIME_SPENT_PER_WEEK_METADATA"] = "screensTimeSpentPerWeekMetadata";
    FirestoreCollectionsProcessedEnumLevel2["ACTIVITIES_TIME_SPENT_PER_WEEK"] = "activitiesTimeSpentPerWeek";
    FirestoreCollectionsProcessedEnumLevel2["ACTIVITIES_TIME_SPENT_PER_WEEK_METADATA"] = "activitiesTimeSpentPerWeekMetadata";
})(FirestoreCollectionsProcessedEnumLevel2 || (FirestoreCollectionsProcessedEnumLevel2 = {}));
